import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import "babel-polyfill";
import store from "./store";
Vue.config.productionTip = false;

// fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
library.add(faUserSecret, faX);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

// quillEditor
import { quillEditor } from "vue3-quill";
Vue.use(quillEditor);

// google GA4 tag 등록
import VueGtag from "vue-gtag";
import VueTagManager from "vue-tag-manager";
import VueHead from "vue-head";

// meta tag
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  keyName: "metaInfo",
  ssrAttribute: "data-vue-meta-server-rendered",
  refreshOnceOnNavigation: true,
});

// 캐럿 글로벌, 솔루션즈
import carrotglobal from "./route/carrotglobal";
import carrotenglish from "./route/carrotenglish";

// 랜딩
import mangotalk from "./route/mangotalk";
import carrotchinese from "./route/carrotchinese";
import malangtalk from "./route/malangtalk";
import centerone from "./route/centerone";

// 게이트
import gijangcamp from "./route/gijangcamp";
import skbioscience from "./route/skbioscience";
import ongjinenglish from "./route/ongjinenglish";
import uljinenglish from "./route/uljinenglish";
// import jinjuenglish from "./route/jinjuenglish";
// import anyangenglish from "./route/anyangenglish";
// import asyouthenglish from "./route/asyouthenglish";
// import hscarrot from "./route/hscarrot";

// 컨퍼런스
import conf2024 from "./route/conf2024";

// 리로케이션
import expatcare from "./route/expatcare";

const host = window.location.href;
const domain = new URL(host).hostname;
let routes;
if (
  // 캐럿글로벌
  domain == "carrotglobal.com" ||
  domain == "www.carrotglobal.com" ||
  domain == "stage-biz.carrotglobal.com"
) {
  routes = carrotglobal;
} else if (
  // 캐럿솔루션즈
  domain == "carrotenglish.com" ||
  domain == "biz.carrotenglish.com" ||
  domain == "stage-biz.carrotenglish.com"
) {
  routes = carrotenglish;
} else if (
  // 망고톡
  domain == "mangotalk.co.kr" ||
  domain == "www.mangotalk.co.kr" ||
  domain == "stage.mangotalk.co.kr" ||
  domain == "localhost"
) {
  routes = mangotalk;
  routes.beforeEach((to, from, next) => {
    // 페이지 타이틀 및 메타 태그 설정
    document.title = to.meta.title;

    if (to.meta.metaTags) {
      to.meta.metaTags.forEach((tag) => {
        let element = document.querySelector(`meta[name="${tag.name}"]`);
        const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = "/img/icons/mangotalk-fav.png";
        if (element) {
          element.setAttribute("content", tag.content);
        } else {
          element = document.createElement("meta");
          element.setAttribute("name", tag.name);
          element.setAttribute("content", tag.content);
          document.getElementsByTagName("head")[0].appendChild(element);
        }
      });
    }
    next();
  });
} else if (
  // 당근중국어
  domain == "carrotchinese.co.kr" ||
  domain == "www.carrotchinese.co.kr" ||
  domain == "stage.carrotchinese.co.kr" ||
  domain == "carrotchinese.com" ||
  domain == "www.carrotchinese.com" ||
  domain == "stage.carrotchinese.com"
) {
  routes = carrotchinese;
} else if (
  // 말랑톡
  domain == "malangtalk.com" ||
  domain == "www.malangtalk.com" ||
  domain == "stage.malangtalk.com" ||
  domain == "malangtalk.co.kr" ||
  domain == "www.malangtalk.co.kr" ||
  domain == "stage.malangtalk.co.kr" ||
  domain == "aitutoring.co.kr" ||
  domain == "www.aitutoring.co.kr" ||
  domain == "stage.aitutoring.co.kr"
) {
  routes = malangtalk;
  routes.beforeEach((to, from, next) => {
    // 페이지 타이틀 및 메타 태그 설정
    document.title = to.meta.title;

    if (to.meta.metaTags) {
      to.meta.metaTags.forEach((tag) => {
        let element = document.querySelector(`meta[name="${tag.name}"]`);
        const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = "/img/icons/malangtalk-fav.png";
        if (element) {
          element.setAttribute("content", tag.content);
        } else {
          element = document.createElement("meta");
          element.setAttribute("name", tag.name);
          element.setAttribute("content", tag.content);
          document.getElementsByTagName("head")[0].appendChild(element);
        }
      });
    }
    next();
  });
} else if (
  // 센터원
  domain == "centerone.kr" ||
  domain == "www.centerone.kr" ||
  domain == "stage.centerone.kr"
) {
  routes = centerone;
} else if (
  // 기장
  domain == "gijangcamp.co.kr" ||
  domain == "www.gijangcamp.co.kr" ||
  domain == "stage.gijangcamp.co.kr"
) {
  routes = gijangcamp;
} else if (
  // sk바이오사이언스
  domain == "carrotskbiosc.co.kr" ||
  domain == "www.carrotskbiosc.co.kr" ||
  domain == "stage.carrotskbiosc.co.kr"
) {
  routes = skbioscience;
} else if (
  // 옹진
  domain == "ongjinenglish.com" ||
  domain == "www.ongjinenglish.com"
) {
  routes = ongjinenglish;
} else if (
  // 컨퍼런스
  domain == "conf2024.carrotglobal.com" ||
  domain == "stage-conf2024.carrotglobal.com"
) {
  routes = conf2024;
} else if (
  // 리로케이션
  domain == "expatcare.co.kr" ||
  domain == "www.expatcare.co.kr" ||
  domain == "stage.expatcare.co.kr"
) {
  routes = expatcare;
} else if (
  // 울진
  domain == "uljinenglish.com" ||
  domain == "www.uljinenglish.com"
) {
  routes = uljinenglish;
}
// 진주
// } else if (
//   domain == "jinjuenglish.com" ||
//   domain == "www.jinjuenglish.com" ||
//   domain == "life.jinjuenglish.com"
// ) {
//   routes = jinjuenglish;
// 안양
// else if (
//   domain == "anyangenglish.com" ||
//   domain == "www.anyangenglish.com"
// ){
//   routes = anyangenglish;
// }
// 아산
// else if (
//   domain == "asyouthenglish.com" ||
//   domain == "www.asyouthenglish.com"
// ) {
//   routes = asyouthenglish;
// }
// 화성
// else if (
//   domain == "hscarrot.co.kr" ||
//   domain == "www.hscarrot.co.kr"
// ) {
//   routes = hscarrot;
// }

Vue.use(VueHead);
// 캐럿글로벌
Vue.use(VueGtag, {
  config: {
    id: "G-M1FBGF5Z7C",
    params: {
      send_page_view: false,
      linker: {
        domains: ["www.carrotglobal.com", "carrotglobal.com"],
      },
    },
  },
  enabled: window.location.hostname === "www.carrotglobal.com" || window.location.hostname === "carrotglobal.com",
});

// 당근중국어
Vue.use(VueGtag, {
  config: {
    id: "GTM-KLVFDPT6",
  },
  enabled:
    window.location.hostname === "carrotchinese.com" ||
    window.location.hostname === "www.carrotchinese.com" ||
    window.location.hostname === "carrotchinese.co.kr" ||
    window.location.hostname === "www.carrotchinese.co.kr",
});
Vue.use(VueTagManager, {
  gtmId: "GTM-KLVFDPT6",
  isEnabled:
    window.location.hostname === "carrotchinese.com" ||
    window.location.hostname === "www.carrotchinese.com" ||
    window.location.hostname === "carrotchinese.co.kr" ||
    window.location.hostname === "www.carrotchinese.co.kr",
});

new Vue({
  router: routes,
  store,
  render: (h) => h(App),
}).$mount("#app");
